module.exports = {
    licence:{
        Robot_problem_solved:'已解决',
        Robot_problem_unsolved:'未解决',
        Robot_emptyMassege_reminder:"不能发送空消息",
        Robot_massege_ViewMore:'查看全部',
        Robot_massege_ViewLess:'收起',
        Robot_greetings_1:'你好，我能为你做什么？',
        Robot_greetings_2:'试着输入关键词找答案吧。',
        Robot_closing_1_1:'这个问题我还不太确定',
        Robot_closing_1_2:"点击  ",
        Robot_closing_1_login_1:'噢，抱歉！我还在学习中。',
        Robot_closing_1_login_2:'请尝试使用其他关键字！',
        Robot_closing_2:'这里 ',
        Robot_closing_3:'联系人工客服，我们会尽快回复您',
        Robot_problem_unsolved_reply:'抱歉没有帮助到您，点击这里联系人工客服，我们会尽快联系您',
        Robot_TypeHere:'在这里输入',
        Robot_greetings_label1:'将数据合并到新应用程序中',
        Robot_greetings_label2:'迁移后数据丢失',
        Robot_greetings_label3:'秤在迁移后断开连接',
        Robot_greetings_label4:'迁移后的小贴士',
        Robot_greetings_label5:'显示在卡片中的图形',
        Robot_greetings_label6:'查看体重历史记录',
        Robot_greetings_label7:'查看体围历史记录',
        Robot_greetings_label8:'如何获得帮助',
        Robot_greetings_label9:'其他问题',
        key_internet_error:'网络异常，请检查网络设置',
        Robot_title_Beta:'聊天机器人',
        Robot_greetings_label1_login:'忘记密码',
        Robot_greetings_label2_login:'如何重置密码',
        Robot_greetings_label3_login:'将数据合并到新应用程序中',
        Robot_greetings_label4_login:'为什么有两个应用程序',
        Robot_greetings_label5_login:'账户登录注意事项',
        Robot_greetings_label6_login:"是否需要在新应用程序重新注册",
        Robot_greetings_label7_login:"我在两个应用程序上都有账户，该如何处理",
        Robot_greetings_label8_login:'如何获得帮助',
        Robot_greetings_label9_login:'其他',
        Robot_greetings_label1_devicePage:'添加设备的方法',
        Robot_greetings_label2_devicePage:'通过“添加设备弹窗”添加设备',
        Robot_greetings_label3_devicePage:'手动添加设备',
        Robot_greetings_label4_devicePage:'配对Wifi蓝牙秤的小贴士',
        Robot_greetings_label5_devicePage:'如何配对Wifi',
        Robot_greetings_label6_devicePage:"设备没有在“已配对列表”下",
        Robot_greetings_label7_devicePage:"删除设备",
        Robot_greetings_label8_devicePage:'如何获得帮助',
        Robot_greetings_label9_devicePage:'其他',
        Robot_greetings_label1_mePage:'我可以更改主用户吗',
        Robot_greetings_label2_mePage:'如何编辑主用户资料',
        Robot_greetings_label3_mePage:'查看好友的数据',
        Robot_greetings_label4_mePage:'添加好友',
        Robot_greetings_label5_mePage:'如何发送好友请求',
        Robot_greetings_label6_mePage:"如何查看好友请求",
        Robot_greetings_label7_mePage:"删除朋友",
        Robot_greetings_label8_mePage:'如何获得帮助',
        Robot_greetings_label9_mePage:'其他',
        Robot_greetings_label1_balancePage:'体重数据未同步到 APP',
        Robot_greetings_label2_balancePage:'如何检查蓝牙故障',
        Robot_greetings_label3_balancePage:'应用程序只显示体重和BMI',
        Robot_greetings_label4_balancePage:'肌肉读数显示为“- -”',
        Robot_greetings_label5_balancePage:'秤的称重不正确',
        Robot_greetings_label6_balancePage:"体脂百分比读书出现重大变化",
        Robot_greetings_label7_balancePage:"手动输入体重数据",
        Robot_greetings_label8_balancePage:'切换到另一个测量用户',
        Robot_greetings_label9_balancePage:'其他',
        Robot_greetings_label1_tapPage:'如何使用卷尺',
        Robot_greetings_label2_tapPage:'切换到另一侧两用户',
        Robot_greetings_label3_tapPage:'查看体围趋势图',
        Robot_greetings_label4_tapPage:'查看体围历史记录',
        Robot_greetings_label5_tapPage:'手动输入体围数据',
        Robot_greetings_label6_tapPage:"如何获得帮助",
        Robot_greetings_label7_tapPage:"其他",
        savetoAlbum: "已保存到相册",
        key_cancel: '取消',
        key_confirm: '确定',
        key_deleted: '已成功删除',
        key_delete_popup: '历史记录删除后将无法恢复，您确认要删除吗?',
        key_delete_history: '删除聊天记录',
        key_delete_confirmation: '删除确认'
    }
}